const lateFeeNotificationMessage = 'The lodgement deadline for this change has passed. A late lodgement fee may apply.';

function isNWeeksPassed(theDate: Date, weeks: number, today = new Date()): boolean {
  const dateOnly = new Date(theDate);

  today.setHours(0, 0, 0, 0);
  dateOnly.setHours(0, 0, 0, 0);

  const daysPassed = Math.floor(
    (today.getTime() - dateOnly.getTime()) / (1000 * 60 * 60 * 24)
  );

  return daysPassed > weeks * 7;
}

export function getForm205LateFeeNotification(changeDate: Date, today = new Date()): string | null {
  // Example for Form 205:
  // Date of change is 01.06.2025
  // Lodgement Deadline is 15.06.2025
  //
  // The warning should appear for the user, starting from 16.06.2025,
  // which is the day after the lodgement deadline

  const form205LateFeeWeeks = 2;
  const shouldApplyLateFee = isNWeeksPassed(changeDate, form205LateFeeWeeks, today);

  return shouldApplyLateFee ? lateFeeNotificationMessage : null;
}

export function getForm484LateFeeNotification(changeDate: Date): string | null {
  const form484LateFeeWeeks = 4;
  const shouldApplyLateFee = isNWeeksPassed(changeDate, form484LateFeeWeeks);

  return shouldApplyLateFee ? lateFeeNotificationMessage : null;
}
